import { useRef, useState } from 'react';

import { DotsIcon } from '../../../../assets/svg/DotsIcon';
import { useClickOutside } from '../../../../hooks/useClickOutside';
import { Beneficiary } from '../../../../models/payouts';
import { DropdownContainer, DropdownItem, DropdownList, SimpleButton } from './styles';

interface Options {
	label: string;
	onClick: (rowData: Beneficiary) => void;
	colorCustom?: string;
}

interface DropdownProps {
	options: Options[];
	disabled?: boolean;
	rowData: Beneficiary;
}

const DropDown = ({ options, rowData }: DropdownProps) => {
	const [isDropdownVisible, setIsDropdownVisible] = useState<boolean>(false);
	const modal = useRef<HTMLDivElement>(null);

	const toogleDropdown = () => {
		setIsDropdownVisible(!isDropdownVisible);
	};

	const handleItemClick = (onClick: (rowData: Beneficiary) => void) => {
		onClick(rowData);
		setIsDropdownVisible(false);
	};

	useClickOutside({ elementRef: modal, callback: () => setIsDropdownVisible(false) });

	return (
		<SimpleButton onClick={toogleDropdown}>
			<DotsIcon />
			{isDropdownVisible && (
				<DropdownContainer ref={modal}>
					<DropdownList>
						{options?.map(({ label, onClick, colorCustom }) => (
							<DropdownItem
								key={label}
								onClick={() => handleItemClick(onClick)}
								colorCustom={colorCustom}
							>
								{label}
							</DropdownItem>
						))}
					</DropdownList>
				</DropdownContainer>
			)}
		</SimpleButton>
	);
};

export default DropDown;
